module.exports = __webpack_public_path__ + "img/choose-up-13_4 virtual_text.56f1845e.png";